var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoweredByBose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_15762",
    "data-name": "Group 15762",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.672,
    height: 44.96,
    viewBox: "0 0 38.672 44.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6971",
    "data-name": "Rectangle 6971",
    width: 38.672,
    height: 44.96,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15761",
    "data-name": "Group 15761",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6969",
    "data-name": "Rectangle 6969",
    width: 38.672,
    height: 44.96,
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15760",
    "data-name": "Group 15760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15759",
    "data-name": "Group 15759",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13827",
    "data-name": "Path 13827",
    d: "M30.549,31.686h.977a.819.819,0,0,1,.915.826v.007a.855.855,0,0,1-.967.84h-.4v.717h-.526Zm.943,1.206a.37.37,0,0,0,.417-.362v-.007c0-.236-.164-.362-.427-.362h-.406v.731Z",
    transform: "translate(-26.684 -27.677)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13828",
    "data-name": "Path 13828",
    d: "M53.743,32.605V32.6a1.271,1.271,0,0,1,2.541-.007V32.6a1.271,1.271,0,0,1-2.541.007m1.991,0V32.6a.726.726,0,0,0-.724-.751.715.715,0,0,0-.717.744V32.6a.726.726,0,0,0,.724.751.715.715,0,0,0,.717-.744",
    transform: "translate(-46.943 -27.394)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13829",
    "data-name": "Path 13829",
    d: "M80.986,31.638h.564l.5,1.619.536-1.626h.451l.536,1.626.5-1.619h.55L83.8,34.046h-.458l-.54-1.564-.54,1.564H81.8Z",
    transform: "translate(-70.739 -27.629)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13830",
    "data-name": "Path 13830",
    d: "M118.732,31.686h1.8v.468h-1.281v.485h1.127v.468h-1.127v.5h1.3v.468h-1.82Z",
    transform: "translate(-103.709 -27.677)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13831",
    "data-name": "Path 13831",
    d: "M142.815,31.685h1.093a.953.953,0,0,1,.7.243.75.75,0,0,1,.2.546v.007a.742.742,0,0,1-.512.741l.584.854h-.615l-.512-.765h-.413v.765h-.526Zm1.059,1.161c.256,0,.4-.137.4-.338V32.5c0-.225-.157-.341-.413-.341h-.523v.687Z",
    transform: "translate(-124.745 -27.676)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13832",
    "data-name": "Path 13832",
    d: "M168.331,31.686h1.8v.468h-1.281v.485h1.127v.468h-1.127v.5h1.3v.468h-1.82Z",
    transform: "translate(-147.032 -27.677)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13833",
    "data-name": "Path 13833",
    d: "M192.415,31.686h.932a1.192,1.192,0,0,1,1.27,1.189v.007a1.2,1.2,0,0,1-1.27,1.2h-.932Zm.526.475V33.6h.407a.681.681,0,0,0,.721-.714v-.007a.687.687,0,0,0-.721-.721Z",
    transform: "translate(-168.069 -27.677)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13834",
    "data-name": "Path 13834",
    d: "M233.616,31.686h1.11a.863.863,0,0,1,.625.212.547.547,0,0,1,.164.406v.007a.556.556,0,0,1-.314.516.584.584,0,0,1,.447.587v.007c0,.437-.355.656-.895.656h-1.137Zm1.376.707c0-.157-.123-.246-.345-.246h-.519v.505h.485c.232,0,.379-.075.379-.253Zm-.256.7h-.608v.526h.625c.232,0,.372-.082.372-.26v-.007c0-.16-.119-.26-.389-.26",
    transform: "translate(-204.057 -27.677)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13835",
    "data-name": "Path 13835",
    d: "M257.269,33.134l-.919-1.448h.615l.57.96.581-.96h.6l-.919,1.438v.953h-.526Z",
    transform: "translate(-223.915 -27.676)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6970",
    "data-name": "Rectangle 6970",
    width: 32.391,
    height: 32.391,
    transform: "translate(3.14 9.718)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13836",
    "data-name": "Path 13836",
    d: "M156.489,192.391a.746.746,0,0,0-.639.37c-.121.211-.464.807-.587,1.018a.294.294,0,0,0,.256.444h2.038l-.366.633a.3.3,0,0,1-.26.154h-.317a.126.126,0,0,1-.111-.183c.038-.069.122-.211.122-.211h-1.847l-.268.464a.3.3,0,0,0,.253.451h3.452a.749.749,0,0,0,.65-.379c.131-.229.441-.768.574-1a.3.3,0,0,0-.248-.456h-2.037l.376-.652a.3.3,0,0,1,.251-.137h.318a.125.125,0,0,1,.115.172c-.033.059-.128.222-.128.222h1.845l.277-.479a.3.3,0,0,0-.261-.436Z",
    transform: "translate(-134.922 -168.048)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13837",
    "data-name": "Path 13837",
    d: "M121.071,192.391h-3.449a.756.756,0,0,0-.644.366l-1.347,2.334a.3.3,0,0,0,.257.442h3.455a.753.753,0,0,0,.644-.367l1.346-2.331a.3.3,0,0,0-.261-.443m-1.738.707c-.05.085-.967,1.675-1.018,1.764a.3.3,0,0,1-.257.149h-.321a.125.125,0,0,1-.11-.182l1.023-1.772a.3.3,0,0,1,.255-.145h.322a.123.123,0,0,1,.106.186",
    transform: "translate(-100.965 -168.048)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13838",
    "data-name": "Path 13838",
    d: "M58.567,192.391h-3.9l-1.513,2.62h-3.5v.522h7.178a.746.746,0,0,0,.647-.373c.138-.238.354-.614.447-.776a.3.3,0,0,0-.178-.422.759.759,0,0,0,.634-.366c.125-.215.323-.563.437-.76a.3.3,0,0,0-.254-.446M56.5,194.409c-.046.081-.2.35-.264.457a.289.289,0,0,1-.254.146H55l.455-.788h.933a.124.124,0,0,1,.108.185m.756-1.311c-.046.081-.2.35-.264.457a.289.289,0,0,1-.254.146h-.978l.455-.788h.933a.124.124,0,0,1,.108.185",
    transform: "translate(-43.373 -168.048)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13839",
    "data-name": "Path 13839",
    d: "M193.415,192.391l-1.814,3.142H196l.3-.522h-2.551l.455-.788h2.551l.3-.523H194.5l.455-.789h4.788v-.521Z",
    transform: "translate(-167.359 -168.048)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13840",
    "data-name": "Path 13840",
    d: "M156.489,192.391a.746.746,0,0,0-.639.37c-.121.211-.464.807-.587,1.018a.294.294,0,0,0,.256.444h2.038l-.366.633a.3.3,0,0,1-.26.154h-.317a.126.126,0,0,1-.111-.183c.038-.069.122-.211.122-.211h-1.847l-.268.464a.3.3,0,0,0,.253.451h3.452a.749.749,0,0,0,.65-.379c.131-.229.441-.768.574-1a.3.3,0,0,0-.248-.456h-2.037l.376-.652a.3.3,0,0,1,.251-.137h.318a.125.125,0,0,1,.115.172c-.033.059-.128.222-.128.222h1.845l.277-.479a.3.3,0,0,0-.261-.436Z",
    transform: "translate(-134.922 -168.048)",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13841",
    "data-name": "Path 13841",
    d: "M121.071,192.391h-3.449a.756.756,0,0,0-.644.366l-1.347,2.334a.3.3,0,0,0,.257.442h3.455a.753.753,0,0,0,.644-.367l1.346-2.331a.3.3,0,0,0-.261-.443m-1.738.707c-.05.085-.967,1.675-1.018,1.764a.3.3,0,0,1-.257.149h-.321a.125.125,0,0,1-.11-.182l1.023-1.772a.3.3,0,0,1,.255-.145h.322a.123.123,0,0,1,.106.186",
    transform: "translate(-100.965 -168.048)",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13842",
    "data-name": "Path 13842",
    d: "M58.567,192.391h-3.9l-1.513,2.62h-3.5v.522h7.178a.746.746,0,0,0,.647-.373c.138-.238.354-.614.447-.776a.3.3,0,0,0-.178-.422.759.759,0,0,0,.634-.366c.125-.215.323-.563.437-.76a.3.3,0,0,0-.254-.446M56.5,194.409c-.046.081-.2.35-.264.457a.289.289,0,0,1-.254.146H55l.455-.788h.933a.124.124,0,0,1,.108.185m.756-1.311c-.046.081-.2.35-.264.457a.289.289,0,0,1-.254.146h-.978l.455-.788h.933a.124.124,0,0,1,.108.185",
    transform: "translate(-43.373 -168.048)",
    fill: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13843",
    "data-name": "Path 13843",
    d: "M193.415,192.391l-1.814,3.142H196l.3-.522h-2.551l.455-.788h2.551l.3-.523H194.5l.455-.789h4.788v-.521Z",
    transform: "translate(-167.359 -168.048)",
    fill: "#101010"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredByBose);
export default __webpack_public_path__ + "static/media/powered-by-bose.f00c09efdcff2b3451c91a76017fb1ff.svg";
export { ForwardRef as ReactComponent };